<template>
    <b-row class="pb-4">
        <b-col  class="d-flex flex-column">
                <Pagination
                    v-if="objects.length > 1"
                    :features="objects"
                    :indexStart="selectedIndex"
                    @indexChanged="$_onIndexChanged($event)"
                />
        </b-col>
    </b-row>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import Pagination from '../../../Pagination.vue';

    export default {
        props: {
            mode: { type: String, default: 'all' },
            select: { type: Boolean, default: true },
            zoom: { type: Boolean, default: true }
        },
        components: { 'Pagination': Pagination },
        computed: {
            ...mapState(['selectedItemIndex']),
            ...mapGetters(['getSelectionGroups', 'getSelectionObjectsSelectedGroup', 'getSelectionObjects', 'getSelectionObjectsSelectedItem']),
            objects() {
                return this.mode === 'all' ? this.getSelectionObjects : this.getSelectionObjectsSelectedGroup.objects;
            },
            selectedIndex() {
                if (this.mode === 'all') {
                    return this.getSelectionObjects.findIndex(item => item.id === this.getSelectionObjectsSelectedItem.id);
                }
                return this.selectedItemIndex;
            },
        },
        methods: {
            ...mapActions(['updateSelectionPointer', 'zoomToFeatures']),
            $_onIndexChanged(objectIndex) {
                if (!this.select) {
                    return;
                }
                if (this.mode === 'all') {
                    const newItem = this.getSelectionObjects[objectIndex];
                    const group = this.getSelectionGroups
                        .findIndex(item => item.layer.id === newItem.layer.id);
                    const index = this.getSelectionGroups[group].objects
                        .findIndex(item => item.id === newItem.id);
                    this.updateSelectionPointer({ group, index });
                } else {
                    this.updateSelectionPointer({ index:  objectIndex });
                }
                if (!this.zoom) {
                    return;
                }
                this.zoomToFeatures({
                    features: [this.getSelectionObjectsSelectedItem.feature],
                    zoomWhenOutOfView: false
                });
            }
        }
    };
</script>
